module.exports = __webpack_public_path__ + "img/pastthehill.45c084e3.png";